import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '@services/local-storage/local-storage.service';


export const roleGuard: CanActivateFn = (route, state) => {
	const authService = inject(LocalStorageService);
	const router = inject(Router);
	const expectedRoles = route.data['role'] as string[] | undefined;


	if (authService.getUser()) {
		const userRole = JSON.parse(authService.getUser()).currentRole.toLowerCase();
		if (expectedRoles != userRole) {
			router.navigate(['/auth/login']);
			return false
		}
	} else {
		const token = authService.getTokenAuth();
		const parts = token.split('.');
		const encodedHeader = parts[1];
		const userRole = JSON.parse(atob(encodedHeader)).role[0].roleName.toLowerCase();
		if (expectedRoles != userRole) {
			router.navigate(['/auth/login']);
			return false
		}

	}

	return true;
};
